'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = require('semantic-ui-react');

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _dyzioInstagramEmbed = require('../dyzio-instagram-embed');

var _dyzioInstagramEmbed2 = _interopRequireDefault(_dyzioInstagramEmbed);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var avatarStyle = {
  width: 90,
  height: 90,
  float: 'left'
};

var brandHandleStyle = {
  marginBottom: '0px'
};

var brandNameStyle = {
  color: 'grey',
  marginTop: '0px'
};

var leftMargin = {
  paddingTop: '20px',
  marginLeft: '100px'
};

var brandHeaderStyle = {
  width: '380px',
  border: '1px solid white',
  margin: '0px auto'
};

var plainCardStyle = { boxShadow: 'none', webkitBoxShadow: 'none' };
var cardGroupStyle = { clear: 'both', paddingTop: '10px' };

var BrandMentionsPostList = function (_Component) {
  (0, _inherits3.default)(BrandMentionsPostList, _Component);

  function BrandMentionsPostList() {
    (0, _classCallCheck3.default)(this, BrandMentionsPostList);

    var _this = (0, _possibleConstructorReturn3.default)(this, (BrandMentionsPostList.__proto__ || (0, _getPrototypeOf2.default)(BrandMentionsPostList)).call(this));

    _this.state = {
      savedThumbnailUrl: '',
      error: false,
      loading: true
    };
    return _this;
  }

  (0, _createClass3.default)(BrandMentionsPostList, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var brandId, params, _ref2, status, data, _JSON$parse, savedThumbnailUrl;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                brandId = this.props.brandId;
                _context.prev = 1;
                params = {
                  data: {
                    instagramId: brandId
                  }
                };
                _context.next = 5;
                return _axios2.default.post('https://9uvsiskwi2.execute-api.eu-west-1.amazonaws.com/production/instagram/profile/picture', params);

              case 5:
                _ref2 = _context.sent;
                status = _ref2.status;
                data = _ref2.data;


                if (_lodash2.default.isEqual(status, 200)) {
                  console.log('SUCCESS');
                  _JSON$parse = JSON.parse(_lodash2.default.get(data, 'body')), savedThumbnailUrl = _JSON$parse.data.savedThumbnailUrl;

                  this.setState({
                    savedThumbnailUrl: savedThumbnailUrl,
                    loading: false
                  });
                } else {
                  this.setState({
                    error: true,
                    loading: false
                  });
                }
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](1);

                console.log(_context.t0);
                this.setState({
                  error: true,
                  loading: false
                });

              case 15:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 11]]);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          savedThumbnailUrl = _state.savedThumbnailUrl,
          loading = _state.loading;
      var _props = this.props,
          brandName = _props.brandName,
          brandHandle = _props.brandHandle,
          shortcodes = _props.shortcodes;


      console.log('brand profile image', savedThumbnailUrl);

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: brandHeaderStyle },
          loading && _react2.default.createElement(_semanticUiReact.Message, {
            header: 'Loading Image'
          }),
          savedThumbnailUrl && !loading && _react2.default.createElement(_semanticUiReact.Image, {
            src: savedThumbnailUrl,
            className: 'circular',
            style: avatarStyle
          }),
          _react2.default.createElement(
            'div',
            { style: leftMargin },
            _react2.default.createElement(
              'h3',
              { style: brandHandleStyle },
              brandName
            ),
            _react2.default.createElement(
              'h5',
              { style: brandNameStyle },
              brandHandle
            )
          ),
          _react2.default.createElement('div', { style: { clear: 'both' } })
        ),
        _react2.default.createElement('hr', null),
        _react2.default.createElement(
          _semanticUiReact.Card.Group,
          {
            centered: true,
            itemsPerRow: shortcodes.length > 2 ? 3 : shortcodes.length,
            style: cardGroupStyle
          },
          _lodash2.default.map(shortcodes, function (code) {
            return _react2.default.createElement(
              _semanticUiReact.Card,
              { key: code, style: plainCardStyle },
              _react2.default.createElement(_dyzioInstagramEmbed2.default, {
                assetId: '' + code,
                maxWidth: true
              })
            );
          })
        )
      );
    }
  }]);
  return BrandMentionsPostList;
}(_react.Component);

BrandMentionsPostList.propTypes = {
  brandName: _propTypes2.default.string.isRequired,
  brandId: _propTypes2.default.string.isRequired,
  brandHandle: _propTypes2.default.string.isRequired,
  shortcodes: _propTypes2.default.array.isRequired
};

exports.default = BrandMentionsPostList;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/brand-mentions-post-list/index.js
 ** module id = 966
 ** module chunks = 0
 **/